/* tsparticles engine bootstrap. Slim is loaded once on first request and
   cached as a Promise so concurrent callers all wait on the same load. */

import { tsParticles } from "@tsparticles/engine";
import { loadEmittersPlugin } from "@tsparticles/plugin-emitters";
import { loadSlim } from "@tsparticles/slim";

let preparedPromise: Promise<void> | null = null;

/** Load slim + emitters once; subsequent callers wait on the same promise. */
export function prepareEngine(): Promise<void> {
  if (!preparedPromise) {
    preparedPromise = (async () => {
      await loadSlim(tsParticles);
      await loadEmittersPlugin(tsParticles);
    })();
  }
  return preparedPromise;
}

export { tsParticles };

/** True when the user has asked the OS to reduce motion. Effects should
   suppress themselves entirely in that case. */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** Bright celebration palette — used for both per-cell pops and the
   win-burst confetti. Deliberately distinct from the muted cell-revealed
   palette (#6aaa64 green, #c9b458 yellow) so a pop reads as celebration
   rather than as more signal. */
export const CELEBRATION_PALETTE = [
  "#ffd700", // gold
  "#ff3ea5", // hot pink
  "#4ade80", // lime
  "#22d3ee", // cyan
  "#fb923c", // vivid orange
  "#a855f7", // purple
];
